import React, { FC, useEffect } from 'react';

import { FormSectionHopInCodeProps } from './FormSectionHopInCode.types';

const FormSectionHopInCode: FC<FormSectionHopInCodeProps> = ({
  ticketType,
  register,
  formData,
  setValue,
}) => {
  useEffect(() => {
    if (typeof setValue === 'function') {
      setValue(
        'hopInIntegrationCode',
        formData.hopinIntegrationCodeVirtual && ticketType !== 'In person'
          ? formData.hopinIntegrationCodeVirtual
          : formData.hopinIntegrationCode,
      );
    }
  }, [ticketType, formData, setValue]);

  return (
    <input
      name='hopInIntegrationCode'
      id='hopInIntegrationCode'
      data-testid='hopInIntegrationCode'
      {...register('hopInIntegrationCode')}
      value={
        formData.hopinIntegrationCodeVirtual && ticketType !== 'In person'
          ? formData.hopinIntegrationCodeVirtual
          : formData.hopinIntegrationCode
      }
      type='hidden'
    />
  );
};

export default FormSectionHopInCode;
